































import {Component, Vue} from 'vue-property-decorator'
import TheNumberOfPlayersSelector from "@/components/player-information/TheNumberOfPlayersSelector.vue";
import {Game} from "@/models/Game";
import TheNamesInput from "@/components/player-information/TheNamesInput.vue";
import TheGameLoop from "@/components/TheGameLoop.vue";
import EndScreen from "@/components/TheEndScreen.vue";
import {localStorageService} from "@/services/localstorage/LocalStorageService";

@Component({
    components: {TheGameLoop, TheNamesInput, TheNumberOfPlayersSelector, EndScreen}
})
export default class TheGameWindow extends Vue {

    private showNumberOfPlayersSelector = true;
    private showNamingInput = false;
    private showGameLoop = false;
    private showEndScreen = false;
    private reloaded = false;

    private game: Game = new Game();

    mounted() {
        if (localStorageService.isPresent()) {
            this.game = localStorageService.getGame();
            this.reloaded = true;
            this.openGameLoop();
        }
    }


    private setNumberOfPlayersAndOpenNamingComponent(game: Game) {
        this.game = game;
        this.closeNumberOfPlayersSelectorAndOpenNamesInput();
    }

    private closeNumberOfPlayersSelectorAndOpenNamesInput() {
        this.showNumberOfPlayersSelector = false;
        this.showNamingInput = true;
    }

    private closeNamingInputAndOpenNumberOfPlayersSelector() {
        this.showNamingInput = false;
        this.showNumberOfPlayersSelector = true;
    }

    private closeGameLoopAndOpenEndScreen() {
        this.showGameLoop = false;
        this.showEndScreen = true;
    }

    private updateGame(game: Game) {
        this.game = game;
        localStorageService.setGame(game);
    }

    private openGameLoop() {
        localStorageService.setGame(this.game)
        this.showNumberOfPlayersSelector = false;
        this.showNamingInput = false;
        this.showGameLoop = true;
    }

    private newGame() {
        localStorageService.removeGame()
        this.reloaded = false;
        this.showGameLoop = false;
        this.showEndScreen = false;
        this.game = new Game();
        this.showNumberOfPlayersSelector = true;
    }
}
